/*
 * Important: When modifying existing routes check if they are used in our backends and/or by Data analysis dashboards
 */

export const SwanOAuthRedirectRoute = '/swan-oauth-redirect';
export const SwanPaymentConsentRoute = '/swan-payment-consent';
